export default __webpack_public_path__ + "static/media/partners-logo-duoback-w@2x.6479b0bf.webp";